(() => {
  const headers = document.querySelectorAll('.storefront-header');

  headers.forEach((header) => {
    const toggle = header.querySelector('.storefront-menu-toggle');
    if (!toggle) return;

    const setOpen = (open) => {
      header.classList.toggle('is-menu-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    };

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    header.querySelectorAll('.storefront-nav a').forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  });

  // Pop-ups de l'en-tête : un <dialog> natif (affiché au premier plan, au-dessus de tout le reste) remplace la navigation.
  // - rubriques pas encore prêtes (data-coming-soon) : message « en cours de développement » ;
  // - rubriques de contact (data-contact) : contenu du <template data-contact-template> de l'en-tête.
  // Les rubriques du menu sont repérées sur leur titre affiché : il suffit que l'un de ses mots soit dans la liste
  // (« Blog », « Le blog », « Qui sommes-nous ? »…), sans tenir compte des majuscules ni de la ponctuation.
  const toWords = (text) => text.toLowerCase().normalize('NFKC').split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  const toKeywords = (list) => (list || '').split(',').map((title) => toWords(title).join(' ')).filter(Boolean);
  const matches = (keywords, words) => keywords.some((keyword) => words.includes(keyword) || words.join(' ') === keyword);

  headers.forEach((header) => {
    const contactKeywords = toKeywords(header.dataset.contactLinks);
    const comingSoonKeywords = toKeywords(header.dataset.comingSoonLinks);

    header.querySelectorAll('.storefront-nav a').forEach((link) => {
      const words = toWords(link.textContent);
      if (matches(contactKeywords, words)) link.setAttribute('data-contact', '');
      else if (matches(comingSoonKeywords, words)) link.setAttribute('data-coming-soon', '');
    });
  });

  const popupTriggers = document.querySelectorAll('.storefront-header [data-coming-soon], .storefront-header [data-contact]');

  if (popupTriggers.length) {
    const dialog = document.createElement('dialog');
    dialog.className = 'storefront-popup';
    dialog.innerHTML = `
      <button type="button" class="storefront-popup__close" aria-label="Fermer">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>
      </button>
      <div class="storefront-popup__body"></div>
    `;
    document.body.appendChild(dialog);

    const bodyEl = dialog.querySelector('.storefront-popup__body');
    dialog.querySelector('.storefront-popup__close').addEventListener('click', () => dialog.close());
    // Un clic en dehors de la carte (sur le fond) ferme aussi le pop-up.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    popupTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const header = trigger.closest('.storefront-header');
        const contactTemplate = header?.querySelector('[data-contact-template]');

        if (trigger.hasAttribute('data-contact') && contactTemplate) {
          bodyEl.replaceChildren(contactTemplate.content.cloneNode(true));
        } else {
          const message = document.createElement('p');
          message.className = 'storefront-popup__message';
          message.textContent = header?.dataset.comingSoonMessage || 'Cette rubrique est en cours de développement :)';
          bodyEl.replaceChildren(message);
        }
        if (!dialog.open) dialog.showModal();
      });
    });
  }

  const carousels = document.querySelectorAll('.storefront-carousel');

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    if (!track || (!prevBtn && !nextBtn)) return;

    const scrollByCard = (direction) => {
      const card = track.querySelector('.storefront-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      const amount = (card.getBoundingClientRect().width + gap) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    };

    const updateArrows = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.classList.toggle('is-disabled', track.scrollLeft <= 1);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', track.scrollLeft >= maxScroll - 1);
    };

    prevBtn?.addEventListener('click', () => scrollByCard(-1));
    nextBtn?.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });

  const lightbox = document.querySelector('[data-lightbox]');

  if (lightbox) {
    const imageEl = lightbox.querySelector('[data-lightbox-image]');
    const counterEl = lightbox.querySelector('[data-lightbox-counter]');
    const prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    const nextBtn = lightbox.querySelector('[data-lightbox-next]');
    let images = [];
    let index = 0;
    let lastFocused = null;

    const render = () => {
      if (!images.length || !imageEl) return;
      imageEl.src = images[index];
      imageEl.alt = lightbox.dataset.title || '';
      const multi = images.length > 1;
      if (counterEl) counterEl.textContent = multi ? `${index + 1} / ${images.length}` : '';
      if (prevBtn) prevBtn.hidden = !multi;
      if (nextBtn) nextBtn.hidden = !multi;
    };

    const open = (urls, title) => {
      images = urls;
      index = 0;
      lightbox.dataset.title = title || '';
      render();
      lightbox.hidden = false;
      document.body.classList.add('storefront-lightbox-open');
      lastFocused = document.activeElement;
      lightbox.querySelector('[data-lightbox-close]')?.focus();
    };

    const close = () => {
      lightbox.hidden = true;
      document.body.classList.remove('storefront-lightbox-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    document.querySelectorAll('[data-lightbox-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const raw = trigger.getAttribute('data-lightbox-images') || '';
        const urls = raw.split('|').map((url) => url.trim()).filter(Boolean);
        if (!urls.length) return;
        open(urls, trigger.getAttribute('data-lightbox-title'));
      });
    });

    lightbox.querySelectorAll('[data-lightbox-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    prevBtn?.addEventListener('click', () => {
      index = (index - 1 + images.length) % images.length;
      render();
    });

    nextBtn?.addEventListener('click', () => {
      index = (index + 1) % images.length;
      render();
    });

    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') prevBtn?.click();
      if (event.key === 'ArrowRight') nextBtn?.click();
    });
  }
})();
